import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
  switchFieldContainer:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    height: 50,
    border: '1px solid #E0E0E0',
    borderRadius: 6,
    padding: '5px 10px',
    boxSizing: 'border-box',
  },
  switchFieldLabel:{
    fontSize: 16,
    fontWeight: 400,
    color: '#29132E',
    fontFamily: 'Roboto',
  },
  switchOptionsContainer:{
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  switchOptionText:{
    fontSize: 16,
    width: 100,
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  optionOn:{
    textAlign: 'left',
  },
  optionOff:{
    textAlign: 'right',
  },
}));

export default useStyles;
